import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';
import {ObjectBaseComponent} from '../../../../core/shared/object/mvs-object-base/object-base.component';
import {
    LgFlowTraceDetailPanelComponent,
} from '../../component/protected-components/lg-flow-trace-detail-panel/lg-flow-trace-detail-panel.component';

/**
 * @ticket TM-1000001563
 * CRUD service for `lg.LogicFlowTrace`. Backs the registry-driven
 * MvsCoreService.getObjectComponent fallback path used by
 * MvsGenericObjectPageComponent when the navigation service routes to
 * `/object?objectType=lg.LogicFlowTrace&objectId=:id` in a new browser tab.
 *
 * Returning the OBC explicitly via `getObjectComponent()` avoids the
 * registry's resolveComponentMapping fallback being skipped at runtime
 * (which previously caused a redirect to the home page).
 */
@Injectable({
    providedIn: 'root',
})
export class LogicFlowTraceService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/lg/logicFlowTraces');
    }

    /**
     * @ticket TM-1000001563
     * Returns the ObjectBaseComponent that the navigation service should
     * mount inside MvsGenericObjectPageComponent for `lg.LogicFlowTrace`.
     */
    override getObjectComponent(
        mode: MvsCrudModeEnum = MvsCrudModeEnum.update,
        viewType?: any,
    ): Type<ObjectBaseComponent> {
        return LgFlowTraceDetailPanelComponent;
    }
}
